import axiosClient from '../service/axiosClient';
import { saveToken, deleteToken } from './localStorage';

export interface FbInstantLoginResult {
  token: string;
}

/**
 * Returns true when the app is running inside a Facebook Instant Games context.
 */
export const isFbInstantContext = (): boolean => {
  return typeof FBInstant !== 'undefined' && FBInstant !== null;
};

/**
 * Authenticates via Facebook Instant Games:
 * 1. Gets a signed player info token from the FBInstant SDK
 * 2. Sends it to the server for HMAC-SHA256 verification
 * 3. Returns a JWT token on success
 */
export const fbInstantLogin = async (): Promise<FbInstantLoginResult> => {
  if (!isFbInstantContext()) {
    return Promise.reject(new Error('Not in a Facebook Instant Games context'));
  }

  const signedPlayerInfo = await FBInstant.player.getSignedPlayerInfoAsync('login');

  const playerId = signedPlayerInfo.getPlayerID();
  const signature = signedPlayerInfo.getSignature();
  const playerName = FBInstant.player.getName() || '';

  return axiosClient
    .request({
      url: 'user/login/fb-instant',
      method: 'post',
      data: { playerId, signature, playerName },
      withCredentials: false
    })
    .then((response) => {
      saveToken(response.data.token);
      return response.data as FbInstantLoginResult;
    })
    .catch((error) => {
      deleteToken();
      console.log('FB Instant login error', error);
      return Promise.reject(error);
    });
};
